import React, { useState } from "react";
import { NoAuthApiRequest,ApiRequest } from "../pages/services/apiservice";
import { ApiEndpoints,ApiEndpointMethod } from "../utils/endpoints";
import  Loader from '../pages/shared/loader'
import { useNavigate } from "react-router";

import { ToastContainer, toast } from "react-toastify";

const Header = ({ toggleCollapse }) => {
    const navigate = useNavigate();
        
    const usrDetails = JSON.parse(localStorage.getItem("user"));
    const [loader, setLoader] = useState(false);
    const [formData, setFormData] = useState({
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      });

      const handleInputChange = (e) => {
        const { name, value } = e.target;
    
        // Update the individual field in the state
        setFormData((prevData) => ({
          ...prevData,      // Spread the previous state
          [name]: value     // Update only the changed field
        }));
      };

      
      const handleChangeTigger = (name, value) => {
  
        setFormData((prevState) => ({
         ...prevState,
         [name]: value,
       }));
 };

      const ClearModel= async()=>{
        await handleChangeTigger("oldPassword","");
        await handleChangeTigger("newPassword","");
        await handleChangeTigger("confirmPassword","");
      }
      
      const validatePassword = async(password,confirmpass) => {
        //const errors = [];
        // Check password length
        var checkPassword=true;
        if(password !=confirmpass){
            checkPassword=false;
            toast.error("New password should be match with the confirm password", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
        else if (password.length < 8) {
         // errors.push("Password must be at least 8 characters.");
          checkPassword=false;
            toast.error("Password must be at least 8 characters.", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
        // Check for at least one uppercase letter
        else if (!/[A-Z]/.test(password)) {
         // errors.push("Password must contain at least one uppercase letter.");
          checkPassword=false;
          toast.error("Password must contain at least one uppercase letter.", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
          });
        }
        // Check for at least one lowercase letter
       else if (!/[a-z]/.test(password)) {
         // errors.push("Password must contain at least one lowercase letter.");
          checkPassword=false;
          toast.error("Password must contain at least one lowercase letter.", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
          });
        }
        // Check for at least one number
        else if (!/\d/.test(password)) {
          //errors.push("Password must contain at least one number.");
          checkPassword=false;
          toast.error("Password must contain at least one number.", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
          });
        }
        // Check for at least one special character
        else if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
          //errors.push("Password must contain at least one special character.");
          checkPassword=false;
          toast.error("Password must contain at least one special character.", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
          });
        }
        return checkPassword;
      };

      const SavePassword = async()=>{
            try{
               
                if(await validatePassword(formData.newPassword,formData.confirmPassword))
                {
             setLoader(true);
             const formDatas = {
                UserId: usrDetails.Id,
                Password: formData.oldPassword,
                NewPassword:formData.newPassword
              };
             
                const data = await ApiRequest(ApiEndpoints.User.UpdatePassword, ApiEndpointMethod.Post, formDatas, navigate);
              if(data==""){
                document.getElementById('btnClose').click();
                toast.success("Password updated successfully", {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "light",
                            });
              }
              else{
                toast.error(data, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
              }
            }
            }
            catch(error){
                
            }
            finally{
                setLoader(false);
            }
      }

    return (
        <>
            <div className="header">
                <a onClick={toggleCollapse}>
                    <i className="fas fa-bars"></i>
                </a>
                <div className="dropdown">
                    <a className="dropdown-toggle text-white" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                        <img src="/assets/images/Felicity_Smoak.jpg" height="30px" className="rounded me-2" />
                        <span>{usrDetails?.Name}</span>
                    </a>
                    <ul className="dropdown-menu">
                        <li><a className="dropdown-item" data-bs-toggle="modal"
                            data-bs-target="#updatePassword">Update Password</a></li>
                    </ul>
                </div>
            </div>

            <div className="modal fade" id="updatePassword" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog">
                    <form>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Update Password</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" id="btnClose" onClick={ClearModel}></button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group">
                                <label>Old Password<span className="text-danger">*</span></label>
                                <input className="form-control" type="password"
                                    value={formData.oldPassword}
                                    name="oldPassword"
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="form-group">
                                <label>New Password<span className="text-danger">*</span></label>
                                <input className="form-control" type="password"
                                    value={formData.newPassword}
                                    name="newPassword"
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="form-group">
                                <label>Confirm Password<span className="text-danger">*</span></label>
                                <input className="form-control" type="password"
                                    value={formData.confirmPassword}
                                    name="confirmPassword"
                                    onChange={handleInputChange}
                                />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" id="btnClose" className="btn btn-sm btn-outline-info me-2"
                                data-bs-dismiss="modal" onClick={ClearModel}>
                                <i className="fas fa-times me-2"></i>Cancel
                            </button>
                            <button type="button" className="btn btn-sm btn-info" onClick={SavePassword}>
                                <i className="fas fa-check me-2"></i>Save
                            </button>
                        </div>
                    </div>
                    </form>
                </div>
            </div>
             {loader && (
                            <Loader/>
                        )}
        </>
    );
};

export default Header;